import request from '@/utils/request'

export function signin(email, password) {
  return request({
    url: '/auth/signin',
    method: 'post',
    data: {
      email,
      password
    }
  })
}

export function resign() {
  return request({
    url: '/auth/resign',
    method: 'post',
    data: {
    }
  })
}

export function me() {
  return request({
    url: '/auth/me',
    method: 'get'
  })
}

export function signout() {
  return request({
    url: '/auth/signout',
    method: 'get'
  })
}

export function challenge(form) {
  return request({
    url: '/auth/challenge',
    method: 'post',
    data: form
  })
}

export function verify(form) {
  return request({
    url: '/auth/verify',
    method: 'post',
    data: form
  })
}

export function reset(email, password, onetimepassword) {
  return request({
    url: '/auth/reset',
    method: 'post',
    data: {
      email,
      password,
      onetimepassword,
    }
  })
}

export function changePassword(password) {
  return request({
    url: '/auth/change-password',
    method: 'post',
    data: {
      password
    }
  })
}

export function changeEmail(password) {
  return request({
    url: '/auth/change-email',
    method: 'post',
    data: {
      password
    }
  })
}

export function toggleIsEnabledAd(is_enabled_ad) {
  return request({
    url: '/auth/toggle-is-enabled-ad',
    method: 'post',
    data: {
      is_enabled_ad
    }
  })
}
